import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Notification.css';
import API_URL from '../../api/ExamCalendarApi';


const Notifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [notificationName, setNotificationName] = useState('');
    const [notificationDate, setNotificationDate] = useState('');
    const [notificationLink, setNotificationLink] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [updateMode, setUpdateMode] = useState(false);
    const [currentNotificationId, setCurrentNotificationId] = useState(null);

    useEffect(() => {
        fetchNotifications();
    }, []);

    const fetchNotifications = async () => {
        try {
            const response = await axios.get(`${API_URL}/homepage/notifications`);
            setNotifications(response.data.notifications);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!notificationName || !notificationDate) {
            setError('Notification name and date are required');
            return;
        }

        const notificationData = { notificationName, notificationDate, notificationLink };

        try {
            if (updateMode) {
                await axios.put(`${API_URL}/homepage/update-notification/${currentNotificationId}`, notificationData);
                setSuccessMessage('Notification updated successfully');
            } else {
                await axios.post(`${API_URL}/homepage/add-notification`, notificationData);
                setSuccessMessage('Notification added successfully');
            }

            setNotificationName('');
            setNotificationDate('');
            setNotificationLink('');
            setUpdateMode(false);
            fetchNotifications();
        } catch (error) {
            setError('Error saving notification');
            setSuccessMessage('');
        }
    };

    const handleDelete = async (notificationId) => {
        try {
            await axios.delete(`${API_URL}/homepage/delete-notification/${notificationId}`);
            setSuccessMessage('Notification deleted successfully');
            fetchNotifications();
        } catch (error) {
            setError('Error deleting notification');
        }
    };

    const handleEdit = (notification) => {
        setNotificationName(notification.notificationName);
        setNotificationDate(notification.notificationDate);
        setNotificationLink(notification.notificationLink);
        setCurrentNotificationId(notification._id);
        setUpdateMode(true);
    };

    return (
        <div className="admin-notification-container">

            <h2 className="admin-notification-title">Manage Notifications</h2>
            

            {error && <div className="admin-notification-error">{error}</div>}
            {successMessage && <div className="admin-notification-success">{successMessage}</div>}

            <form onSubmit={handleSubmit} className="admin-notification-form">
                <div className="admin-notification-form-group">
                    <label htmlFor="notificationName" className="admin-notification-label">Notification Name</label>
                    <input
                        type="text"
                        id="notificationName"
                        className="admin-notification-input"
                        value={notificationName}
                        onChange={(e) => setNotificationName(e.target.value)}
                        placeholder="Enter notification name"
                    />
                </div>

                <div className="admin-notification-form-group">
                    <label htmlFor="notificationDate" className="admin-notification-label">Notification Date</label>
                    <input
                        type="date"
                        id="notificationDate"
                        className="admin-notification-input"
                        value={notificationDate}
                        onChange={(e) => setNotificationDate(e.target.value)}
                    />
                </div>

                <div className="admin-notification-form-group">
                    <label htmlFor="notificationLink" className="admin-notification-label">Notification Link (optional)</label>
                    <input
                        type="url"
                        id="notificationLink"
                        className="admin-notification-input"
                        value={notificationLink}
                        onChange={(e) => setNotificationLink(e.target.value)}
                        placeholder="Enter notification link"
                    />
                </div>

                <button type="submit" className="admin-notification-button">
                    {updateMode ? 'Update Notification' : 'Add Notification'}
                </button>
            </form>

            <h3 className="admin-notification-subtitle">Notifications</h3>
            <div className="admin-notification-table-wrapper">
            <table className="admin-notification-table">
                <thead>
                    <tr>
                        <th>Notification Name</th>
                        <th>Notification Date</th>
                        <th>Notification Link</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {notifications.map((notification) => (
                        <tr key={notification._id}>
                            <td>{notification.notificationName}</td>
                            <td>{notification.notificationDate}</td>
                            <td>{notification.notificationLink ? <a href={notification.notificationLink} target="_blank" rel="noopener noreferrer">Link</a> : '-'}</td>
                            <td>
                                <button className="admin-notification-edit" onClick={() => handleEdit(notification)}>Edit</button>
                                <button className="admin-notification-delete" onClick={() => handleDelete(notification._id)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
        </div>
    );
};

export default Notifications;